<template>
    <div class="text-center">
        <v-dialog v-model="syncBackDialog" width="35%">
            <v-card>
                <v-card-title
                    class="headline red lighten-2"
                    primary-title>
                    <span style="color: white">SYNC BACK</span>
                </v-card-title>
                <v-card-text>
                    <v-container fluid class="p-0 mt-10">
                        <p class="modal-label">Run Sync from these date ranges:</p>
                        <v-row>
                            <v-col cols="auto" class="d-flex">
                                <v-icon class="mr-3">mdi-calendar</v-icon>
                                <v-datetime-picker
                                    v-model="startDate"
                                    timeFormat="HH:mm:ss"
                                    label="Start Date">
                                </v-datetime-picker>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="auto" class="d-flex">
                                <v-icon class="mr-3">mdi-calendar</v-icon>
                                <v-datetime-picker
                                    v-model="endDate"
                                    timeFormat="HH:mm:ss"
                                    label="End Date">
                                </v-datetime-picker>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <small class="text-danger">{{ errors.join(',') }}</small>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        @click="$emit('syncBackModalClose')">
                        Cancel
                    </v-btn>
                    <v-btn
                        small
                        color="primary"
                        :disabled="isProcessing || errors.length > 0"
                        @click="submitSyncByRange">
                        <span v-if="isProcessing">
                            <v-progress-circular
                                    indeterminate
                                    size="12"
                                    width="2"
                                    color="error darken-3">
                            </v-progress-circular>
                            Syncing...
                        </span>
                        <span v-else>Run Sync</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { EventBus } from '../../../event-bus.js'
    import moment from 'moment';

    export default {
        props: {
            integration: {
                type: Number
            },
            limited: {
                type: Boolean,
                default: false
            }
        },

        data : function() {
            return {
                syncBackDialog: true,
                sourceId: '',
                startDate: new Date(moment().subtract(1, 'days')),
                endDate: new Date(moment()),
                errors: [],
                isProcessing: false
            }
        },

        watch: {
            syncBackDialog(value, oldValue) {
                if (value != oldValue) {
                    this.$emit('syncBackModalClose')
                }
            },
            startDate(value, oldValue) {
                if (value != oldValue) {
                    this.validateRange();
                }
            },
            endDate(value, oldValue) {
                if (value != oldValue) {
                    this.validateRange();
                }
            }
        },

        methods: {
            validateRange() {
                if (this.startDate == null || this.endDate == null) {
                    this.errors = ['Both date are required to be filled up.'];
                    return;
                }


                if (this.limited) {
                    var difference = Math.floor((this.endDate - this.startDate)/(24*3600*1000));

                    if (difference > 7) {
                        this.errors = ['Sync back limited to 7 days. Adjust dates and try again.'];
                    } else {
                        this.errors = [];
                    }
                }
            },
            submitSyncByRange() {

                if (this.isProcessing) {
                    return;
                }

                if(this.dateChecker(this.startDate, this.endDate)) {
                    this.errors.push('Please check start/end dates. Make sure start date is before end date')
                    return;
                }

                this.isProcessing = true

                this.errors = [];

                let data = {
                    'integration_id': this.integration,
                    'date_start':  moment(this.startDate).format('YYYY-MM-DD HH:mm:ss'),
                    'date_end':  moment(this.endDate).format('YYYY-MM-DD HH:mm:ss')
                }

                this.$http.post('/api/sync/range', data)
                .then( data => {
                    this.$emit('syncBackModalClose');
                    EventBus.$emit('show-success', 'Successfully run the sync.');
                    this.isProcessing = false
                })
                .catch( err => {
                    this.$emit('syncBackModalClose');
                    EventBus.$emit('show-error', err);
                    this.isProcessing = false
                })
            },

            dateChecker(start, end) {
                return moment(start).isSameOrAfter(end);
            }
        }
    }
</script>

<style scoped>

    .modal-label {
        font-size: large;
        font-weight: normal;
    }

</style>
